var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6001 4V26.2H26.4001V4H3.6001ZM23.2001 20.6H7.2001V19.6H23.2001V20.6ZM23.2001 15.6H7.2001V14.6H23.2001V15.6ZM23.2001 10.6H7.2001V9.6H23.2001V10.6Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActive);
export default __webpack_public_path__ + "static/media/table-active.a68e221f413cae07406f2763743cdbdf.svg";
export { ForwardRef as ReactComponent };